import { createActions } from 'redux-actions';

const {
  // TARIFF TYPES
  getTariffTypes,
  getTariffTypesSuccess,
  getTariffTypesFailure,
  // TARIFF FEE PERIODS
  getTariffFeePeriods,
  getTariffFeePeriodsSuccess,
  getTariffFeePeriodsFailure,
  // TARIFF PRICES
  getTariffPrices,
  getTariffPricesSuccess,
  getTariffPricesFailure,

  getTariffPrice,
  getTariffPriceSuccess,
  getTariffPriceFailure,
} = createActions(
  'GET_TARIFF_TYPES',
  'GET_TARIFF_TYPES_SUCCESS',
  'GET_TARIFF_TYPES_FAILURE',
  'GET_TARIFF_FEE_PERIODS',
  'GET_TARIFF_FEE_PERIODS_SUCCESS',
  'GET_TARIFF_FEE_PERIODS_FAILURE',
  'GET_TARIFF_PRICES',
  'GET_TARIFF_PRICES_SUCCESS',
  'GET_TARIFF_PRICES_FAILURE',
  'GET_TARIFF_PRICE',
  'GET_TARIFF_PRICE_SUCCESS',
  'GET_TARIFF_PRICE_FAILURE'
);

export {
  // TARIFF TYPES
  getTariffTypes,
  getTariffTypesSuccess,
  getTariffTypesFailure,
  // TARIFF FEE PERIODS
  getTariffFeePeriods,
  getTariffFeePeriodsSuccess,
  getTariffFeePeriodsFailure,
  // TARIFF PRICES
  getTariffPrices,
  getTariffPricesSuccess,
  getTariffPricesFailure,
  getTariffPrice,
  getTariffPriceSuccess,
  getTariffPriceFailure,
};
